export const FIRST_INVOICE_NUMBER = 1001;
export const MIN_INVOICE_NUMBER = 1000;

export function normalizeInvoiceNumber(value) {
	if (value === undefined || value === null) {
		return "";
	}

	const normalized = String(value).trim();
	if (!/^\d+$/.test(normalized)) {
		return "";
	}

	const numericValue = Number(normalized);
	if (!Number.isSafeInteger(numericValue) || numericValue < MIN_INVOICE_NUMBER) {
		return "";
	}

	return String(numericValue);
}

export function buildInvoicePrintFilename(template, invoiceId, generatedAt = new Date()) {
	const normalizedTemplate = String(template || "invoice").trim() || "invoice";
	const existingInvoiceId = invoiceId === undefined || invoiceId === null ? "" : String(invoiceId).trim();
	const suffix = existingInvoiceId || generatedAt.toISOString();

	return `${normalizedTemplate}-${suffix}`;
}
